import React, { useCallback, useMemo, useRef, useState } from "react";
import styles from "./map.page.module.scss";

const mapPoints = [
  {
    id: "p-1",
    x: 330.6,
    y: 274.95,
    barangay: "Barangay San Roque",
    sentiment: "Negative",
    color: "#10b981",
    location: "Los Banos, Laguna",
    coordinates: "14.1697, 121.2419",
    campaignCode: "LAG003",
    dateTime: "4/9/2026, 9:30:00 AM",
    enumerator: "Carlos Domingo",
    tone: "enthusiastic",
    concerns: ["None"],
    summary:
      "Very positive about waste segregation program. Commends barangay officials for environmental initiatives and cleanliness drives.",
    demographics: {
      age: "45-54",
      gender: "Female",
      employment: "Government",
      yearsInArea: "Born Here",
      socialClass: "AB",
      education: "College Grad",
    },
    politicalProfile: {
      voterStatus: "Returning",
      voteIntent: "Definite",
      nationalGov: "Helpful",
      localGov: "Helpful",
    },
    valuesMedia: {
      coreValues: "Community",
      primaryMedia: "Facebook",
    },
    leaderPreferences: {
      desired: ["Transparent", "Accountable", "Servant"],
      rejected: ["Corrupt", "Greedy"],
    },
  },
  {
    id: "p-2",
    x: 222.8,
    y: 131.7,
    barangay: "Barangay Maligaya",
    sentiment: "Negative",
    color: "#ef4444",
    location: "Sta. Cruz, Laguna",
    coordinates: "14.2818, 121.4166",
    campaignCode: "LAG007",
    dateTime: "4/10/2026, 10:15:00 AM",
    enumerator: "Ana Mendoza",
    tone: "concerned",
    concerns: ["Flood control", "Public transport"],
    summary:
      "Respondent expressed concern over flood-prone roads and lack of consistent transport during peak hours.",
    demographics: {
      age: "35-44",
      gender: "Male",
      employment: "Private Employee",
      yearsInArea: "15 years",
      socialClass: "C1",
      education: "College Level",
    },
    politicalProfile: {
      voterStatus: "Returning",
      voteIntent: "Leaning",
      nationalGov: "Mixed",
      localGov: "Needs Improvement",
    },
    valuesMedia: {
      coreValues: "Safety",
      primaryMedia: "Facebook",
    },
    leaderPreferences: {
      desired: ["Decisive", "Approachable"],
      rejected: ["Absent", "Corrupt"],
    },
  },
  {
    id: "p-3",
    x: 173.4,
    y: 92.1,
    barangay: "Barangay Riverside",
    sentiment: "Negative",
    color: "#ef4444",
    location: "Pila, Laguna",
    coordinates: "14.2311, 121.3659",
    campaignCode: "LAG011",
    dateTime: "4/10/2026, 1:05:00 PM",
    enumerator: "Ramon Bautista",
    tone: "critical",
    concerns: ["Healthcare access"],
    summary:
      "Respondent highlighted long waiting times in public clinics and limited medicine availability.",
    demographics: {
      age: "55-64",
      gender: "Female",
      employment: "Self-employed",
      yearsInArea: "30 years",
      socialClass: "C2",
      education: "High School",
    },
    politicalProfile: {
      voterStatus: "Returning",
      voteIntent: "Undecided",
      nationalGov: "Needs Improvement",
      localGov: "Needs Improvement",
    },
    valuesMedia: {
      coreValues: "Healthcare",
      primaryMedia: "TV",
    },
    leaderPreferences: {
      desired: ["Transparent", "Compassionate"],
      rejected: ["Greedy"],
    },
  },
  {
    id: "p-4",
    x: 248.8,
    y: 181.65,
    barangay: "Barangay Poblacion",
    sentiment: "Neutral",
    color: "#3b82f6",
    location: "Nagcarlan, Laguna",
    coordinates: "14.1364, 121.4160",
    campaignCode: "LAG014",
    dateTime: "4/11/2026, 8:45:00 AM",
    enumerator: "Maria Santos",
    tone: "measured",
    concerns: ["Road maintenance"],
    summary:
      "Mixed sentiment toward local programs, with strong support for education but concerns about road upkeep.",
    demographics: {
      age: "25-34",
      gender: "Male",
      employment: "Freelancer",
      yearsInArea: "8 years",
      socialClass: "C1",
      education: "College Grad",
    },
    politicalProfile: {
      voterStatus: "New",
      voteIntent: "Leaning",
      nationalGov: "Helpful",
      localGov: "Mixed",
    },
    valuesMedia: {
      coreValues: "Education",
      primaryMedia: "YouTube",
    },
    leaderPreferences: {
      desired: ["Accountable", "Consistent"],
      rejected: ["Corrupt"],
    },
  },
  {
    id: "p-5",
    x: 483.8,
    y: 345.45,
    barangay: "Barangay Bay",
    sentiment: "Positive",
    color: "#10b981",
    location: "Calauan, Laguna",
    coordinates: "14.1498, 121.3158",
    campaignCode: "LAG021",
    dateTime: "4/11/2026, 3:20:00 PM",
    enumerator: "Joel Reyes",
    tone: "optimistic",
    concerns: ["None"],
    summary: "Strong approval of barangay-led livelihood programs and youth employment efforts.",
    demographics: {
      age: "45-54",
      gender: "Male",
      employment: "Business Owner",
      yearsInArea: "Born Here",
      socialClass: "AB",
      education: "College Grad",
    },
    politicalProfile: {
      voterStatus: "Returning",
      voteIntent: "Definite",
      nationalGov: "Helpful",
      localGov: "Helpful",
    },
    valuesMedia: {
      coreValues: "Livelihood",
      primaryMedia: "Facebook",
    },
    leaderPreferences: {
      desired: ["Transparent", "Pro-people"],
      rejected: ["Greedy"],
    },
  },
  {
    id: "p-6",
    x: 651.2,
    y: 497.55,
    barangay: "Barangay Cabuyao",
    sentiment: "Negative",
    color: "#ef4444",
    location: "Cabuyao, Laguna",
    coordinates: "14.2471, 121.1367",
    campaignCode: "LAG028",
    dateTime: "4/12/2026, 11:00:00 AM",
    enumerator: "Liza Cruz",
    tone: "frustrated",
    concerns: ["Traffic", "Water supply"],
    summary:
      "Resident cited worsening traffic and irregular water service as top local pain points.",
    demographics: {
      age: "35-44",
      gender: "Female",
      employment: "Private Employee",
      yearsInArea: "12 years",
      socialClass: "C1",
      education: "College Grad",
    },
    politicalProfile: {
      voterStatus: "Returning",
      voteIntent: "Undecided",
      nationalGov: "Mixed",
      localGov: "Needs Improvement",
    },
    valuesMedia: {
      coreValues: "Reliability",
      primaryMedia: "TikTok",
    },
    leaderPreferences: {
      desired: ["Decisive", "Responsive"],
      rejected: ["Absent", "Corrupt"],
    },
  },
  {
    id: "p-7",
    x: 328.6,
    y: 285.3,
    barangay: "Barangay Calamba",
    sentiment: "Neutral",
    color: "#f59e0b",
    location: "Calamba, Laguna",
    coordinates: "14.2110, 121.1653",
    campaignCode: "LAG031",
    dateTime: "4/12/2026, 4:10:00 PM",
    enumerator: "Mark Villanueva",
    tone: "reserved",
    concerns: ["Job opportunities"],
    summary: "Respondent sees progress in services but wants stronger local job creation programs.",
    demographics: {
      age: "25-34",
      gender: "Female",
      employment: "Unemployed",
      yearsInArea: "5 years",
      socialClass: "C2",
      education: "College Level",
    },
    politicalProfile: {
      voterStatus: "New",
      voteIntent: "Leaning",
      nationalGov: "Helpful",
      localGov: "Mixed",
    },
    valuesMedia: {
      coreValues: "Employment",
      primaryMedia: "Facebook",
    },
    leaderPreferences: {
      desired: ["Accountable", "Visible"],
      rejected: ["Corrupt"],
    },
  },
  {
    id: "p-8",
    x: 210.6,
    y: 120.3,
    barangay: "Barangay Victoria",
    sentiment: "Positive",
    color: "#10b981",
    location: "Victoria, Laguna",
    coordinates: "14.2276, 121.3271",
    campaignCode: "LAG036",
    dateTime: "4/13/2026, 9:05:00 AM",
    enumerator: "Paolo Mercado",
    tone: "hopeful",
    concerns: ["None"],
    summary:
      "Respondent appreciated local scholarship support and highlighted trust in barangay leadership.",
    demographics: {
      age: "18-24",
      gender: "Male",
      employment: "Student",
      yearsInArea: "Born Here",
      socialClass: "C1",
      education: "College",
    },
    politicalProfile: {
      voterStatus: "First-time",
      voteIntent: "Definite",
      nationalGov: "Helpful",
      localGov: "Helpful",
    },
    valuesMedia: {
      coreValues: "Education",
      primaryMedia: "YouTube",
    },
    leaderPreferences: {
      desired: ["Transparent", "Youth-focused"],
      rejected: ["Greedy"],
    },
  },
];

const MapPage = () => {
  const [selectedPointId, setSelectedPointId] = useState(null);
  const detailPanelRef = useRef(null);

  const selectedPoint = useMemo(
    () => mapPoints.find((point) => point.id === selectedPointId) || null,
    [selectedPointId],
  );

  const getSentimentClass = (sentiment) => {
    if (sentiment === "Positive") return styles.badgePositive;
    if (sentiment === "Neutral") return styles.badgeNeutral;
    return styles.badgeNegative;
  };

  const handleMarkerSelect = useCallback((pointId) => {
    setSelectedPointId(pointId);

    if (window.innerWidth <= 1140) {
      detailPanelRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, []);

  return (
    <div className={styles.page}>
      <div className={styles.header}>
        <h1>Geographic Sentiment Map</h1>
        <p>Interactive visualization of survey responses across Laguna</p>
      </div>

      <div className={styles.legendRow}>
        <div className={styles.legendItem}>
          <span className={styles.legendDotPositive} />
          <span>Positive</span>
        </div>
        <div className={styles.legendItem}>
          <span className={styles.legendDotNeutral} />
          <span>Neutral</span>
        </div>
        <div className={styles.legendItem}>
          <span className={styles.legendDotNegative} />
          <span>Negative</span>
        </div>
      </div>

      <div className={styles.contentGrid}>
        <section className={styles.mapPanel}>
          <div className={styles.mapSurface}>
            <svg viewBox="0 0 800 600" className={styles.mapSvg}>
              <defs>
                <pattern id="grid" width="40" height="40" patternUnits="userSpaceOnUse">
                  <path
                    d="M 40 0 L 0 0 0 40"
                    fill="none"
                    stroke="rgba(59, 130, 246, 0.05)"
                    strokeWidth="1"
                  />
                </pattern>
              </defs>

              <rect width="800" height="600" fill="url(#grid)" />

              <g opacity="0.3">
                <path
                  d="M 150 150 L 300 150 L 300 250 L 150 250 Z"
                  fill="rgba(59, 130, 246, 0.1)"
                  stroke="rgba(59, 130, 246, 0.3)"
                  strokeWidth="1"
                />
                <path
                  d="M 350 200 L 500 200 L 500 350 L 350 350 Z"
                  fill="rgba(59, 130, 246, 0.1)"
                  stroke="rgba(59, 130, 246, 0.3)"
                  strokeWidth="1"
                />
                <path
                  d="M 200 350 L 350 350 L 350 500 L 200 500 Z"
                  fill="rgba(59, 130, 246, 0.1)"
                  stroke="rgba(59, 130, 246, 0.3)"
                  strokeWidth="1"
                />
                <path
                  d="M 500 100 L 650 100 L 650 200 L 500 200 Z"
                  fill="rgba(59, 130, 246, 0.1)"
                  stroke="rgba(59, 130, 246, 0.3)"
                  strokeWidth="1"
                />
              </g>

              {mapPoints.map((point) => (
                <g
                  key={point.id}
                  className={`${styles.pointGroup} ${selectedPointId === point.id ? styles.pointActive : ""}`}
                  role="button"
                  tabIndex={0}
                  aria-label={`View details for ${point.barangay}`}
                  onClick={() => handleMarkerSelect(point.id)}
                  onKeyDown={(event) => {
                    if (event.key === "Enter" || event.key === " ") {
                      event.preventDefault();
                      handleMarkerSelect(point.id);
                    }
                  }}
                >
                  <circle
                    cx={point.x}
                    cy={point.y}
                    r="8"
                    fill={point.color}
                    stroke="white"
                    strokeWidth="2"
                  />
                </g>
              ))}
            </svg>

            <div className={styles.overlayBox}>
              <strong>Survey Coverage Map</strong>
            </div>
          </div>
        </section>

        <section className={styles.detailPanel} ref={detailPanelRef}>
          {selectedPoint ? (
            <div className={styles.recordCard}>
              <div className={styles.recordCardInner}>
                <div className={styles.cardHeader}>
                  <h3>Recording Details</h3>
                  <button
                    type="button"
                    className={styles.closeButton}
                    onClick={() => setSelectedPointId(null)}
                    aria-label="Close details"
                  >
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M18 6 6 18" />
                      <path d="m6 6 12 12" />
                    </svg>
                  </button>
                </div>

                <div className={styles.cardScroll}>
                  <div className={styles.cardSection}>
                    <p className={styles.cardLabel}>Location</p>
                    <div className={styles.locationRow}>
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0" />
                        <circle cx="12" cy="10" r="3" />
                      </svg>
                      <div>
                        <p className={styles.cardValue}>{selectedPoint.location}</p>
                        <p className={styles.cardMuted}>{selectedPoint.barangay}</p>
                        <p className={styles.cardCoordinates}>{selectedPoint.coordinates}</p>
                      </div>
                    </div>
                  </div>

                  <div className={styles.cardSection}>
                    <p className={styles.cardLabel}>Date & Campaign</p>
                    <p className={styles.cardValue}>{selectedPoint.dateTime}</p>
                    <div className={styles.codeChip}>{selectedPoint.campaignCode}</div>
                  </div>

                  <div className={styles.cardSection}>
                    <p className={styles.cardLabel}>Enumerator</p>
                    <p className={styles.cardValue}>{selectedPoint.enumerator}</p>
                  </div>

                  <div className={styles.cardSection}>
                    <p className={styles.cardLabel}>Sentiment & Tone</p>
                    <div className={styles.badgeRow}>
                      <span
                        className={`${styles.badge} ${getSentimentClass(selectedPoint.sentiment)}`}
                      >
                        {selectedPoint.sentiment.toUpperCase()}
                      </span>
                      <span className={`${styles.badge} ${styles.badgeTone}`}>
                        {selectedPoint.tone}
                      </span>
                    </div>
                  </div>

                  <div className={styles.cardSection}>
                    <p className={styles.cardLabel}>Key Concerns</p>
                    <div className={styles.concernRow}>
                      {selectedPoint.concerns.map((concern) => (
                        <span key={`${selectedPoint.id}-${concern}`} className={styles.concernTag}>
                          {concern}
                        </span>
                      ))}
                    </div>
                  </div>

                  <div className={styles.cardSection}>
                    <p className={styles.cardLabel}>Summary</p>
                    <p className={styles.cardSummary}>{selectedPoint.summary}</p>
                  </div>

                  <div className={styles.cardSection}>
                    <p className={styles.cardLabel}>Demographics</p>
                    <div className={styles.metaList}>
                      <p>
                        <span>Age:</span> {selectedPoint.demographics.age}
                      </p>
                      <p>
                        <span>Gender:</span> {selectedPoint.demographics.gender}
                      </p>
                      <p>
                        <span>Employment:</span> {selectedPoint.demographics.employment}
                      </p>
                      <p>
                        <span>Years in Area:</span> {selectedPoint.demographics.yearsInArea}
                      </p>
                      <p>
                        <span>Social Class:</span> {selectedPoint.demographics.socialClass}
                      </p>
                      <p>
                        <span>Education:</span> {selectedPoint.demographics.education}
                      </p>
                    </div>
                  </div>

                  <div className={styles.cardSection}>
                    <p className={styles.cardLabel}>Political Profile</p>
                    <div className={styles.metaList}>
                      <p>
                        <span>Voter Status:</span> {selectedPoint.politicalProfile.voterStatus}
                      </p>
                      <p>
                        <span>Vote Intent:</span> {selectedPoint.politicalProfile.voteIntent}
                      </p>
                      <p>
                        <span>National Gov:</span> {selectedPoint.politicalProfile.nationalGov}
                      </p>
                      <p>
                        <span>Local Gov (Mayor):</span> {selectedPoint.politicalProfile.localGov}
                      </p>
                    </div>
                  </div>

                  <div className={styles.cardSection}>
                    <p className={styles.cardLabel}>Values & Media</p>
                    <div className={styles.metaList}>
                      <p>
                        <span>Core Values:</span> {selectedPoint.valuesMedia.coreValues}
                      </p>
                      <p>
                        <span>Primary Media:</span> {selectedPoint.valuesMedia.primaryMedia}
                      </p>
                    </div>
                  </div>

                  <div className={`${styles.cardSection} ${styles.cardSectionLast}`}>
                    <p className={styles.cardLabel}>Leader Preferences</p>
                    <div className={styles.preferenceGroup}>
                      <p>Desired:</p>
                      <div className={styles.badgeRow}>
                        {selectedPoint.leaderPreferences.desired.map((item) => (
                          <span
                            key={`${selectedPoint.id}-desired-${item}`}
                            className={`${styles.badge} ${styles.badgeDesired}`}
                          >
                            {item}
                          </span>
                        ))}
                      </div>
                    </div>
                    <div className={styles.preferenceGroup}>
                      <p>Rejected:</p>
                      <div className={styles.badgeRow}>
                        {selectedPoint.leaderPreferences.rejected.map((item) => (
                          <span
                            key={`${selectedPoint.id}-rejected-${item}`}
                            className={`${styles.badge} ${styles.badgeRejected}`}
                          >
                            {item}
                          </span>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className={styles.detailPrompt}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0" />
                <circle cx="12" cy="10" r="3" />
              </svg>
              <p>Click on a marker to view details</p>
            </div>
          )}
        </section>
      </div>
    </div>
  );
};

export default MapPage;
